import { render } from "./incompatibleDownloadInstructions.vue?vue&type=template&id=3b6043f4&scoped=true&ts=true"
import script from "./incompatibleDownloadInstructions.vue?vue&type=script&lang=ts"
export * from "./incompatibleDownloadInstructions.vue?vue&type=script&lang=ts"

import "./incompatibleDownloadInstructions.vue?vue&type=style&index=0&id=3b6043f4&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b6043f4"]])

export default __exports__